import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1694.06317,564.68396 L1694.06317,1750.49656 C1694.06317,1843.89342 1618.05823,1919.89836 1524.66137,1919.89836 L1524.66137,1919.89836 L395.31604,1919.89836 C301.919181,1919.89836 225.91424,1843.89342 225.91424,1750.49656 L225.91424,1750.49656 L225.91424,564.68396 L1694.06317,564.68396 Z M1217.09546,0 L1340.53291,338.8036 L1920,338.8036 L1920,451.851068 L0,451.851068 L0,338.8036 L571.222869,338.8036 L694.660314,0 L1217.09546,0 Z M677.652373,1581.09476 L790.586907,1581.09476 L790.586907,903.48756 L677.652373,903.48756 L677.652373,1581.09476 Z M1129.39051,1581.09476 L1242.32504,1581.09476 L1242.32504,903.48756 L1129.39051,903.48756 L1129.39051,1581.09476 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTrashSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconTrashSolid, _Component);

  var _super = _createSuper(IconTrashSolid);

  function IconTrashSolid() {
    _classCallCheck(this, IconTrashSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconTrashSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTrash",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTrashSolid.displayName = "IconTrashSolid";
  return IconTrashSolid;
}(Component);

IconTrashSolid.glyphName = 'trash';
IconTrashSolid.variant = 'Solid';
IconTrashSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTrashSolid;
export { IconTrashSolid };